<template>
  <div style="position: relative; height: 700px">
    <div v-if="loading" class="loading-div">
      <Button loading shape="circle" type="primary"></Button>
      <div>loading...</div>
    </div>
    <Form inline class="bill-form">
      <FormItem>
        <Input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 2 }"
          v-model="searchData.keywords"
          :placeholder="$t('keyword')"
        >
        </Input>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="SearchSubmit" icon="md-search">
          {{ $t("search") }}
        </Button>
      </FormItem>

      <FormItem v-if="$hasPermission(354)">
        <Button
          type="primary"
          icon="md-arrow-down"
          @click="operation('export')"
          :disabled="row.status == 9"
        >
          {{ $t("export") }}{{ $t("update") }}
        </Button>
      </FormItem>
      <FormItem v-if="$hasPermission(355)">
        <Upload :before-upload="handleUpload" action="" accept=".xlsx">
          <Button
            type="primary"
            icon="md-add"
            @click="operation('import')"
            :disabled="row.status == 9"
          >
            {{ $t("import") }}{{ $t("update") }}
          </Button>
        </Upload>
      </FormItem>
      <FormItem v-if="$hasPermission(403)">
        <Button
          type="error"
          icon="md-trash"
          @click="hangClick"
          :disabled="selectAll.length == 0 || row.status == 9"
        >
          {{ $t("hang") }}
        </Button>
      </FormItem>
      <FormItem v-if="$hasPermission(414)">
        <Button
          type="error"
          icon="md-trash"
          @click="deleteClick"
          :disabled="selectAll.length == 0 || row.status == 9"
        >
          {{ $t("delete") }}
        </Button>
      </FormItem>
      <FormItem>
        <Button
          type="primary"
          icon="md-arrow-down"
          @click="exportExc"
          :disabled="selectAll.length == 0"
        >
          {{ $t("export") }}
        </Button>
      </FormItem>
    </Form>
    <vxe-table
      border
      stripe
      resizable
      show-overflow
      highlight-hover-row
      ref="xTable"
      :height="550"
      align="center"
      :data="tableData"
      :edit-config="{ trigger: 'click', mode: 'cell' }"
      :scroll-y="{ mode: 'wheel' }"
      @checkbox-change="selectTableAll"
      @checkbox-all="selectTableAll"
    >
      <vxe-column
        v-for="config in tableTitle"
        :key="config.key"
        :type="config.type"
        :field="config.key"
        :title="config.title"
        :width="config.minWidth"
      >
      </vxe-column>
    </vxe-table>
    <div>
      <div class="price-content">
        <div v-for="(item, index) in priceList" :key="index">
          <span class="span-head">
            {{ $t("originalCodAmount") }}{{ item.replace_currency }}:
          </span>
          <span class="span-title">
            {{ item.total_amount }}
          </span>
        </div>
        <span
          class="span-head"
          style="border-left: 1px solid #ccc; padding-left: 10px"
          >{{ $t("total") + $t("bill_proceeds_issuing") + "USD" }}:</span
        >
        <span class="span-title">
          {{ row.total_amount }}
        </span>
      </div>
      <Page
        ref="pageSize"
        :page-size-opts="arrPageSize"
        :total="total"
        show-sizer
        :page-size="searchData.pageSize"
        @on-page-size-change="changeSize"
        @on-change="changePage"
        show-elevator
        show-total
        :current.sync="pageCurrent"
        style="margin-top: 0"
      />
    </div>

    <Modal
      v-model="showModal"
      :title="title"
      @on-visible-change="closedeleteModal"
      class-name="vertical-center-modal"
    >
      <Form
        label-position="right"
        :model="dataDetails"
        :label-width="100"
        :rules="ruleFrom"
        ref="dataDetails"
      >
        <FormItem :label="$t('order_desc')" prop="remarks">
          <Input
            type="textarea"
            v-model="dataDetails.remarks"
            placeholder="Please enter remarks"
            :rows="4"
          >
          </Input>
        </FormItem>
      </Form>
      <div slot="footer" class="footer-modal">
        <Button type="primary" @click="confirmModal('dataDetails')">
          {{ $t("confirm") }}
        </Button>
        <Button @click="closeModal">{{ $t("cancel") }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  getDetails,
  del,
  exportBill,
  importBill,
  deleteShipment,
} from "@/api/finance/codList";
import excel from "@/utils/excel";
import boxMes from "@/utils/message";
export default {
  inject: ["$page"],
  props: {
    row: {
      type: Object,
    },
    close: {
      type: Function,
    },
  },
  data() {
    return {
      searchData: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      arrPageSize: [15, 100, 500, 1000],
      tableData: [],
      total: 0,
      loading: true,
      pageCurrent: 1,
      showModal: false,
      ruleFrom: {
        remarks: [
          {
            required: true,
            message: "Please Enter remarks",
            trigger: "blur",
          },
        ],
      },
      dataDetails: {},
      typeList: ["RECEIVE", "REFUND"],
      hideSelect: true,
      selectAll: [],
      title: "",
      priceList: [],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      if (this.hideSelect) {
        columns.push({
          type: "checkbox",
          width: 60,
          align: "center",
        });
      }
      columns.push({
        title: this.$t("outboundTime"),
        key: "outbound_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$t("clientName"),
        key: "account",
        minWidth: 100,
        align: "center",
        tooltip: "true",
      });
      columns.push({
        title: this.$t("order_number"),
        key: "airway_bill_number",
        align: "center",
        minWidth: 130,
      });
      columns.push({
        title: this.$t("channel_code"),
        key: "transport_mode",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("target_country"),
        key: "to_country",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("city_name"),
        key: "city_name",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("shipperRef"),
        key: "client_refer_code",
        align: "center",
        minWidth: 110,
        tooltip: "true",
      });
      columns.push({
        title: this.$t("agentName"),
        key: "deliver",
        align: "center",
        minWidth: 100,
        tooltip: "true",
      });
      // columns.push({
      //   title: this.$t("17no"),
      //   key: "17no",
      //   align: "center",
      //   minWidth: 100,
      //   tooltip: "true"
      // });
      columns.push({
        title: this.$t("tracker_code"),
        key: "status",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("status_time"),
        key: "status_time",
        align: "center",
        minWidth: 170,
      });
      columns.push({
        title: this.$t("codAmount"),
        key: "cod_amount",
        align: "center",
        minWidth: 120,
      });

      columns.push({
        title: this.$t("cod_ncnd_status"),
        key: "cod_ncnd_status",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("rate"),
        key: "cod_agent_rate",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("bill_proceeds_issuing"),
        key: "bill_proceeds_issuing",
        align: "center",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("bill_proceeds_issuing_charge"),
        key: "bill_proceeds_issuing_charge",
        align: "center",
        minWidth: 100,
      });
      columns.push({
        title: this.$t("bill_proceeds_issuing_confirm"),
        key: "bill_proceeds_issuing_confirm",
        align: "center",
        minWidth: 120,
      });
      columns.push({
        title: this.$t("cod_ncnd_1_time"),
        key: "cod_ncnd_1_time",
        align: "center",
        minWidth: 170,
      });
      return columns;
    },
  },
  mounted() {
    this.SearchSubmit();
  },
  methods: {
    deleteClick() {
      let data = {
        id: this.row.id,
        ids: this.selectAll.map((item) => item.id),
      };
      this.$Modal.confirm({
        title: this.$t("delete"),
        width: 300,
        content: this.$t("titleModal"),
        onOk: () => {
          deleteShipment(data).then((res) => {
            this.$Message[res.data.status ? "success" : "error"]({
              background: true,
              content: res.data.msg,
            });
            if (!res.data.payload.bill_del) {
              this.SearchSubmit();
            } else {
              this.close();
              this.$page.getList();
            }
          });
        },
      });
    },
    handleUpload(file) {
      this.addList(file);
      return false;
    },
    addList(file) {
      let formData = new FormData();
      formData.append("file", file); // 文件对象
      importBill(this.row.id, formData).then((res) => {
        boxMes.alertMes(res, this, 1);
      });
    },
    operation(text) {
      if (text == "export") {
        exportBill(this.row.id).then((res) => {
          window.open(this.$globalUrl + "/" + res.data.payload);
        });
      }
    },
    hangClick() {
      this.title = this.$t("hang");
      if (this.selectAll.length == 0) {
        this.$Message["error"]({
          background: true,
          content: "Operation data cannot be empty",
        });
        return;
      }
      this.showModal = true;
    },
    selectTableAll(val) {
      this.selectAll = val.records;
    },
    exportExc() {
      this.hideSelect = false;
      let arr = this.tableTitle;
      arr.pop();
      excel.exportExcel(
        this.selectAll.length == 0 ? this.tableData : this.selectAll,
        arr,
        this.$t("cod_details") + "(" + this.row.check_bill_number + ")",
        this
      );
      this.hideSelect = true;
      this.SearchSubmit();
    },
    closeModal() {
      this.closedeleteModal(false);
    },
    closedeleteModal(e) {
      if (e === false) {
        this.showModal = false;
        this.searchData.keywords = "";
        this.$refs["dataDetails"].resetFields();
      }
    },
    confirmModal(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let arr = this.selectAll.map((item) => {
            return item.id;
          });
          this.deleteList(arr);
        }
      });
    },
    deleteList(data) {
      this.dataDetails.ids = data;
      del(this.row.id, this.dataDetails).then((res) => {
        if (res.data.status) {
          this.$Message["success"]({
            background: true,
            content: res.data.msg,
          });
          if (!res.data.payload.bill_del) {
            this.SearchSubmit();
          } else {
            this.close();
            this.$page.getList();
          }
        } else {
          this.$Message["error"]({
            background: true,
            content: res.data.msg,
            duration: 5,
          });
        }
      });
    },
    getList(id, data) {
      this.tableData = [];
      this.priceList = [];
      this.loading = true;
      getDetails(this.row.id, data)
        .then((res) => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.tableData = res.data.payload.rows;
          this.priceList = res.data.payload.totalCurrency;
          this.total = res.data.payload.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeSize(val) {
      this.searchData.pageSize = val;
      this.SearchSubmit();
    },
    changePage(val) {
      this.searchData.page = val;
      this.SearchSubmit();
    },
    SearchSubmit() {
      this.getList(this.row.id, this.searchData);
    },
  },
};
</script>

<style scoped lang="less">
.price-content {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.bill-form .ivu-form-item {
  margin-bottom: 10px;
}
.text-red {
  color: red;
  font-weight: bold;
}
</style>
